import * as t from "io-ts"

const LiveAlertDevices = t.type({
    raisedAt: t.string,
    deviceSystemRef: t.string,
    description: t.string,
    alerterUsername: t.string,
    dataset: t.string,
})

const NonCompliantDevices = t.type({
    type: t.string,
    systemReference: t.string,
    status: t.string,
    dataset: t.string,
})

export const ManufacturerDevicesData = t.type({
    topNonCompliantSummary: t.array(NonCompliantDevices),
    topLiveAlerts: t.array(LiveAlertDevices),
    topApprovedSummary: t.array(NonCompliantDevices),
    totDevicesAwaitingAssessment: t.number,
    totDevicesNonCompliant: t.number,
    totLiveAlerts: t.number,
    totEVACDrafts: t.number,
    totEVDCDrafts: t.number,
    totHPDrafts: t.number,
    totEBDrafts: t.number,
    totTTRDrafts: t.number,
})

export type IManufacturerDevicesData = t.TypeOf<typeof ManufacturerDevicesData>
